
define('ldsh!modules/lp_leads/templates/lead_listing_item', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<td class="ed-table-action-td js-show-defaults">\n  <b class="ed-table-action" title="mostrar modal">\n    <i class="ed-icon ed-icon-page" aria-hidden="true"></i>\n  </b>\n</td>\n<td class="ed-table-action-td js-show-integrations">\n  <b class="ed-table-action" title="mostrar modal">\n    <i class="ed-icon ed-icon-page" aria-hidden="true"></i>\n  </b>\n</td>\n';

}
return __p
};});

